import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import TestEmailForm from 'components/modals/TestEmailModal/TestEmailForm';
import { sendPitchTestEmail } from 'redux/actions/pitchActions';
import Dialog from 'components/modals/Dialog';
import DialogTitle from 'components/modals/DialogTitle';

class TestEmailModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    pitchId: PropTypes.number,
    sequenceContactId: PropTypes.string.isRequired,
    sendPitchTestEmail: PropTypes.func.isRequired,
  };

  static defaultProps = {
    pitchId: null,
  };

  sendTestEmail = (formData) => {
    const { pitchId, sequenceContactId, toggle } = this.props;
    try {
      this.props.sendPitchTestEmail(pitchId, { ...formData, sequence_contact: sequenceContactId });
      toggle();
    } catch (error) {
      if (error.errors) {
        throw new SubmissionError(error.errors);
      }
    }
  }

  render() {
    const { isOpen, toggle } = this.props;
    return (
      <Dialog
        open={isOpen}
        onBackdropClick={toggle}
      >
        <DialogTitle id="dialog-title" disableTypography>
          Send test email
        </DialogTitle>
        <TestEmailForm onSubmit={this.sendTestEmail} toggle={toggle} />
      </Dialog>
    );
  }
}

export default connect(
  null,
  {
    sendPitchTestEmail,
  },
)(TestEmailModal);
